const {
    LOGO_MAKER_COUNTRY_CODES,
    LOGO_MAKER_MIN_BUDGET,
    BUDGET_FILTER,
    LOGO_DESIGN_SUBCATEGORY_ID,
    DEFAULT_LOCALE,
    QUERY_LIST
} = require('./constants');

const isLogoDesignSubCategory = ({ categoryIds = {} } = {}) =>
    LOGO_DESIGN_SUBCATEGORY_ID === Number.parseInt(categoryIds.subCategoryId, 10);
const isLogoDesignDLC = ({ dominantLeafCategory } = {}) =>
    LOGO_DESIGN_SUBCATEGORY_ID === Number.parseInt(dominantLeafCategory, 10);

const isLogoMakerLocale = ({ sessionLocale } = {}) => sessionLocale
    ? sessionLocale === DEFAULT_LOCALE
    : true;
const isLogoMakerCountry = ({ countryCode } = {}) => countryCode
    ? LOGO_MAKER_COUNTRY_CODES.includes(countryCode.toLowerCase())
    : true;

const isFirstPage = ({ page } = {}) => page
    ? Number.parseInt(page, 10) === 1
    : true;

const isInLogoMakerBudget = ({ activeFilters = {}, currency = {} } = {}) => {
    const priceRangeId = BUDGET_FILTER,
        priceRangeFilter = activeFilters[priceRangeId];

    if (!priceRangeFilter) {
        return true;

    } else {
        const [, max] = priceRangeFilter;
        return (max / (currency.rate || 1)) > LOGO_MAKER_MIN_BUDGET;
    }
};

const isGuestOrRnc = ({ loggedIn, isRncUser } = {}) => !loggedIn || isRncUser;
const isNonRNC = ({ loggedIn, isRncUser } = {}) => loggedIn && !isRncUser;
const isDesktop = ({ isTouch } = {}) => !isTouch;
const isNotFiB = ({ isBusiness } = {}) => !isBusiness;
const isEligibleSorting = (expectedSorting) => ({ sortBy } = {}) => expectedSorting === sortBy;
const isSearchQueryInList = ({ query = '' } = {}) => QUERY_LIST.includes(query.toLowerCase());

module.exports = {
    isFirstPage,
    isLogoDesignSubCategory,
    isLogoDesignDLC,
    isInLogoMakerBudget,
    isGuestOrRnc,
    isNonRNC,
    isLogoMakerLocale,
    isLogoMakerCountry,
    isLogoDesignSCatOrDLC: (params) => isLogoDesignSubCategory(params) || isLogoDesignDLC(params),
    isDesktop,
    isNotFiB,
    isEligibleSorting,
    isSearchQueryInList
};
